import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { UserSessionService } from '../../services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username = '';
  password = '';
  error = '';

  constructor(
    private _userSessionService: UserSessionService,
    private _router: Router
  ) { }

  ngOnInit() {
    /*
    this._userSessionService.getProffixLogin().subscribe(data => {
      if (data != null) {
        this._router.navigate(['dashboard']);
      }
    });
    */
  }

  login() {
    this.error = '';

    this._userSessionService.sendLogin(this.username, this.password).subscribe(() => {
      this._router.navigate(['dashboard']);
    }, (error) => {
      if (error.Message !== undefined) {
        this.error = error.Message;
      } else {
        this.error = 'Es ist ein unbekannter Fehler aufgetreten';
      }
    });
  }

  public onLoginDataChange() {
    this.error = '';
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/login/login.component.ts